import { useLoggedInUser } from "Hooks/useLoggedInUser";

export const useCurrentUserAccessRights = () => {
  const user = useLoggedInUser();

  return user?.accessRights || [];
};
